import React from "react";
import "../style.css";
import logo from "../../assets/images/pricing/LogoWhite.png";
import PriceIntelligenceLayout from "..";
const SplashScreen = () => {
  return (
    <PriceIntelligenceLayout>
      <div className="pricing-splash">
        <div className="pricing-slpash-img">
          <img src={logo} alt="logo"></img>
        </div>
        <div className="pricing-splash-heading">
          <h1>Price Intelligence</h1>
        </div>
      </div>
    </PriceIntelligenceLayout>
  );
};

export default SplashScreen;
